import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { NgLetModule } from "ng-let";
import { ExportCsvButtonComponent } from "./components/export-csv-button.component";
import { CsvService } from "./services/csv.service";

@NgModule({
  declarations: [
    ExportCsvButtonComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NgLetModule,
  ],
  providers: [
    CsvService,
  ],
  exports: [
    ExportCsvButtonComponent,
  ],
})
export class ExportCsvButtonModule { }
